/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import NavbarTitleBackAction from '/client/src/components/topNavbar/backAction';
import Connect from './connect';
import Settings from './settings';
import { GET, POST } from '/client/src/api';

import './styles.scss';
import { GetErrorValidation } from '../../../utils/errorMessageValidation';

type PropsType = {
  match: {
    params: {
      viewTab?: string
    }
  },
  history: any
};

class IntegrationsMailchimp extends React.Component<PropsType> {
  props: PropsType;

  static contextType = DefaultContainerContext;

  state = {
    mailchimpSettings: {
      apikey: '',
      enable: false,
      enabled: false,
      enableold: true,
      globalsync: false,
      id: '0',
      listid: '',
      listidold: '',
      lists: [],
      sync: false,
      username: ''
    },
    isLoading: false
  }

  componentDidMount() {
    this.init();
  }

  init = async () => {
    try {
      this.toggleLoading(true);
      const { result } = await GET('/api/v1/1/mailchimp');

      this.setState({
        mailchimpSettings: {
          apikey: result.apikey,
          enable: result.enable || false,
          globalsync: result.globalsync || false,
          id: result.id,
          listid: result.listid,
          lists: result.lists || [],
          sync: result.sync,
          username: result.username
        }
      });
      if (result.enable) {
        this.props.history.push('/integrations/mailchimp/settings');
        window.localStorage.setItem('isMailChimpConnected', true);
      } else {
         window.localStorage.setItem('isMailChimpConnected', false);
      }
      this.toggleLoading(false);
    } catch (e) {
      this.toggleLoading(false);
      console.log(e);
    }
  }

  connect = async (username: string, apikey: string) => {
    try {
      this.toggleLoading(true);
      const { result } = await POST('/api/v1/1/mailchimp', {
        ...this.state.mailchimpSettings,
        enable: true,
        apikey,
        username
      });

      this.setState({
        mailchimpSettings: {
          ...this.state.mailchimpSettings,
          ...result
        }
      });

      this.props.history.push('/integrations/mailchimp/settings');

      window.localStorage.setItem('isMailChimpConnected', true);

      this.toggleLoading(false);
    } catch (e) {
      this.toggleLoading(false);

      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Oops!',
        systemDialogContent: <GetErrorValidation data={e.data} />
      });
    }
  }

  disconnect = async () => {
    try {
      this.toggleLoading(true);
      await POST('/api/v1/1/mailchimp', {
        ...this.state.mailchimpSettings,
        enable: false,
        enabled: false,
        enableold: true
      });
      this.setState({
        mailchimpSettings: {
          ...this.state.mailchimpSettings,
          username: null,
          enable: false
        }
      });
      window.localStorage.setItem('isMailChimpConnected', false);
      this.toggleLoading(false);
    } catch (e) {
      this.toggleLoading(false);
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Oops!',
        systemDialogContent: 'Can\'t disconnect'
      });
    }
  }

  handleSettingsChange = async (isGlobalSync: boolean, listId: string, isSync: boolean) => {
    this.toggleLoading(true);
    try {
      await POST('/api/v1/1/mailchimp', {
        ...this.state.mailchimpSettings,
        globalsync: isGlobalSync,
        listid: listId,
        sync: isSync
      });
      this.toggleLoading(false);
    } catch (e) {
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Oops!',
        systemDialogContent: 'Can\'t update'
      });
      this.toggleLoading(false);
      console.log(e);
    }
  }

  toggleLoading = (status: boolean) => {
    this.setState({
      isLoading: status
    });
  }

  render(): React.Element<'div'> {
    const { match } = this.props;
    const {
      mailchimpSettings: {
        enable,
        username,
        sync,
        globalsync,
        lists,
        listid
      },
      isLoading
    } = this.state;

    const { params: { viewTab } } = match;
    const _viewTab = viewTab ? viewTab.toLowerCase() : 'connect';

    return (
      <div className='IntegrationsMailchimp'>
        <NavbarTitleBackAction path='/integrations/' />
        <div className="sparxo-router-content">
          <div className="sparxo-page-container">
            <div className="event-list">
              <div className="sparxo-integrations-cards">
                <div className="sparxo-integrations-list" style={{ margin: '0 0 15px 0' }}>
                  <div
                    className="sparxo-integrations-item"
                    style={{
                      background: 'none',
                      maxWidth: '490px',
                      margin: '0 auto'
                    }}
                  >
                    <div className="media">
                      <div className="media-left">
                        <img
                          src={'/img/mailchimp.png'}
                          alt="mailchimp"
                          className="media-object"
                        />
                      </div>
                      <div className="media-body">
                        <h4 className="media-heading" style={{ fontWeight: 0 }}>
                          Mailchimp
                        </h4>
                        <span>Automatically sync ticket contacts with MailChimp lists</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="panel panel-default panel-page">
                <div className="navbar-page-toolbar customers-navbar mailchimp-navbar">
                  <div className="container-fluid" style={{ height: '50px' }}>
                    <ul className="nav">
                      <li
                        key={'IntegrationsItemMailchimp-menuItems-1'}
                        className={`${(_viewTab) === 'connect' ? 'active' : ''}`}
                      >
                        <Link to={'/integrations/mailchimp/connect'}>
                          Connect
                        </Link>
                      </li>
                      {
                        enable &&
                        <li
                          key={'IntegrationsItemMailchimp-menuItems-2'}
                          className={`${(_viewTab) === 'settings' ? 'active' : ''}`}
                        >
                          <Link to={'/integrations/mailchimp/settings'}>
                            Account sync settings
                          </Link>
                        </li>
                      }
                    </ul>
                    {
                      enable &&
                      <ul className="nav pull-right">
                        <li>{username}</li>
                      </ul>
                    }
                  </div>
                </div>

                <div className="panel-body" style={{ minHeight: '500px' }}>
                  { _viewTab === 'connect' ?
                    <Connect
                      isLoading={isLoading}
                      enable={enable}
                      username={username}
                      connect={this.connect}
                      disconnect={this.disconnect}
                    />
                    :
                    <Settings
                      isLoading={isLoading}
                      globalsync={globalsync}
                      listid={listid}
                      sync={sync}
                      lists={lists}
                      onHandleSettingsChange={this.handleSettingsChange}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(IntegrationsMailchimp);
